var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegenerateSparkle = function SvgRegenerateSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9a.75.75 0 0 1 .75.75c0 .826.674 1.5 1.5 1.5a.75.75 0 0 1 0 1.5c-.826 0-1.5.674-1.5 1.5a.75.75 0 0 1-1.5 0c0-.826-.674-1.5-1.5-1.5a.75.75 0 0 1 0-1.5c.826 0 1.5-.674 1.5-1.5a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.085 3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3.42a.75.75 0 0 1 0-1.5h1.548a3.75 3.75 0 1 0-3.915 6.041.75.75 0 0 1-.426 1.438A5.248 5.248 0 0 1 3.125 8.45a5.244 5.244 0 0 1 5.25-5.25c1.58 0 2.995.7 3.96 1.805V3.75a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgRegenerateSparkle;